/** 收入覆盖与收入专属时间窗；实时用户/行为计数继续消费各自时间口径。 */
import type { FinancialCoverage } from '@novel-admin/shared/schemas/financial-coverage';
export function IncomeCoverageNotice({ coverage }: { coverage: FinancialCoverage | undefined }) {
  return (
    <div className="hint" style={{ marginBottom: 12 }}>
      {!coverage
        ? '收入覆盖状态未确认，收入指标暂不可用。'
        : !coverage.usd_ready
          ? `收入覆盖尚未就绪${coverage.missing_app_ids.length ? ` · ${coverage.missing_app_ids.length} 个 App 待确认` : ''}，其他计数可独立查看。`
          : coverage.data_as_of && coverage.income_window
            ? `收入截至 ${coverage.data_as_of}（右开） · 收入窗口 ${coverage.income_window.start} 至 ${coverage.income_window.end}`
            : '原生收入覆盖已核验；计数与行为数据使用各自时间窗。'}
    </div>
  );
}
